/**
 * "Còn thiếu để đăng ký tên miền": what a subject still lacks, the same for every TLD — the gaps
 * against the rules every domain follows once, then only what a registry or registrar needs
 * beyond them ("WebNIC cần thêm: …"), and one "Sửa chủ thể" for the whole list. First the
 * verification still to do (owner decision 2026-10-01: an individual by eKYC only, an
 * organisation by its subject declaration "bản khai chủ thể"). Used by the
 * subject page, the customer page and the new-customer screen. Grouping: ../../lib/readiness.ts.
 */

import { useTranslation } from 'react-i18next';
import { api } from '../../api';
import { Callout } from '../../components/blocks';
import { groupReadiness } from '../../lib/readiness';
import { useApi } from '../../lib/useApi';
import { EditSubjectActions, ProblemList, VerificationGap } from '../domains/RegistrationStop';

export function ReadinessPanel({ subjectId, compact = false }: { subjectId: string; compact?: boolean }) {
  const { t } = useTranslation('domains');
  const r = useApi((signal) => api.getSubjectRegistryReadiness(subjectId, { signal }), [subjectId]);
  if (r.status !== 'success' || (r.data.registries.length === 0 && !r.data.verification)) return null;
  const g = groupReadiness(r.data);
  if (g.ready) {
    return (
      <div data-readiness="ready">
        <Callout tone="ok">{t('subject.readiness.ready')}</Callout>
      </div>
    );
  }
  const all = [...g.baseline, ...g.extras.flatMap((x) => x.problems)];
  return (
    <div data-readiness="missing">
    <Callout tone="warn" title={t('subject.readiness.missingTitle')}>
      <div className="grid gap-3">
        {g.verification ? <VerificationGap v={g.verification} subjectId={subjectId} link={!compact} /> : null}
        {g.baseline.length ? <ProblemList problems={g.baseline} /> : null}
        {g.extras.map((x) => (
          <div key={x.registryCode} className="grid gap-1" data-readiness-extra={x.registryCode}>
            <span className="text-xs font-medium text-muted-foreground">
              {t('subject.readiness.extraFor', { name: x.registryName })}
              {compact ? null : <span className="font-normal"> · {x.zones.map((z) => `.${z}`).join(' ')}</span>}
            </span>
            <ProblemList problems={x.problems} />
          </div>
        ))}
        <EditSubjectActions problems={all} />
      </div>
    </Callout>
    </div>
  );
}
